export const localStorageKeys = {
  TOKEN: "token",
  I18NEXTLNG: "i18nextLng",
  MY_INFO: "my_info",
  MODE: "mode",
  TIME: "_time",
  i18: "i18nextLng",
};
